import * as React from 'react';
import { addSubjectColorsNew } from '../../../ta-services/ta-utils';

type TaResultSummaryBarProps = {
	subject: string;
	currentValue: number;
	maxValue: number;
	barColor: string;
};

export const TaResultSummaryBar = ({
	subject,
	currentValue,
	maxValue,
	// barColor,
}: TaResultSummaryBarProps) => {
	return (
		<div className='ta-result-summary-bar_container'>
			<div className='ta-result-summary-bar_details'>
				<div>{subject}</div>
				<div>
					<span>{currentValue}</span>/{maxValue}
				</div>
			</div>
			<div className='ta-result-summary-bar_bar'>
				<div
					className='ta-result-summary-bar_bar-fill'
					style={{width: currentValue * (220 / maxValue!), backgroundColor: addSubjectColorsNew(currentValue).barFillColor}}
				/>
			</div>
		</div>
	);
};
